/**
 * SummaryStep.validation.js
 *
 * Pure function, no React. Per FSD UC-02: "All required fields across
 * Screens 2-11 (as applicable) must be valid" before Generate Diet Plan
 * can fire. Every prior step already gates its own Next button on its own
 * validation, so by the time someone reaches Summary in the normal flow
 * every required section is already populated — this is a defensive
 * completeness check (each required section is present at all), not a
 * re-validation of every individual field.
 */

export function validateSummary({
  basicInfo,
  goal,
  lifestyle,
  activity,
  medical,
  foodPreferences,
  mealSchedule,
  womensHealth,
  isFemale,
}) {
  const errors = {};

  if (!basicInfo) errors.basicInfo = "Basic information is incomplete.";
  if (!goal) errors.goal = "Goal is not set.";
  if (!lifestyle) errors.lifestyle = "Lifestyle details are incomplete.";
  if (!activity) errors.activity = "Activity level is incomplete.";
  if (!medical) errors.medical = "Medical information is incomplete.";
  if (!foodPreferences) errors.foodPreferences = "Food preferences are incomplete.";
  if (!mealSchedule) errors.mealSchedule = "Meal schedule is incomplete.";
  // Likes/Dislikes are optional per the FSD, so they're intentionally not
  // checked here.
  if (isFemale && !womensHealth) {
    errors.womensHealth = "Women's health details are incomplete.";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}
